import { TrackJS } from 'trackjs'
import settings from 'settings'
import { getClient } from 'features/common/utils/clientParameter'
import { store } from './state/store'

export function registerTrackers() {
  if (settings.enableTrackJs) {
    enableTrackJS()
  }

  if (import.meta.env.DEV) {
    spyClientIsAttachedToApiRequest()
  }
}

function enableTrackJS() {
  TrackJS.install({
    token: 'cf7a7cd8411140689ea94e92d9fba842',
    application: 'carto-3-workspace-www',
    version: settings.commitHash || undefined, // If is not defined then ignore
    console: { display: false },
    network: { error: false },
    onError: (payload) => {
      payload.metadata.push({
        key: 'section',
        value: getClient()
      })
      payload.metadata.push({
        key: 'account',
        value: store.getState().account.data.id
      })
      return true
    }
  })

  TrackJS.addMetadata('cartoVersion', settings.cartoVersion)
}

function spyClientIsAttachedToApiRequest() {
  const checkIsPublicAPI = (url: string) => {
    return /\/v3\/(maps|workflows|stats|imports|sql|lds)/.test(url)
  }

  const checkIfClientIsInURL = (urlString: string) => {
    const url = new URL(urlString, window.location.href)
    const client = url.searchParams.get('client')
    return client && /^(workspace|builder|workflows-ui|workflows-api|workflows-schedule)$/.test(client)
  }

  const logWarningMessage = (request: Request, payload?) => {
    console.warn(
      `%cMissing client!\n`,
      'font-size: 18px',
      `${request.method} - ${request.url}: Please, check if client parameter should be present here.\n`,
      ...(payload ? ['MORE INFO >>\n', payload] : [])
    )
  }

  window.fetch = new Proxy(window.fetch, {
    apply: (target, that, args) => {
      // If first param is not a request we'll do nothing. That's because all our fetch calls have a request as the first param.
      // Please, if you notice that we're not catching some call then check it and modify if is necessary.

      if (typeof args[0] === 'object' && args[0] instanceof Request) {
        const request: Request = args[0]
        const isCallingToPublicApi = checkIsPublicAPI(request.url)

        if (isCallingToPublicApi) {
          const method = request.method
          if (method === 'GET' || method === 'DELETE') {
            !checkIfClientIsInURL(request.url) && logWarningMessage(request)
          } else if (method === 'POST' || method === 'PUT' || method === 'PATCH') {
            if (!checkIfClientIsInURL(request.url)) {
              const cloneRequest = request.clone()
              cloneRequest.json().then((payload) => {
                if (!payload.client) {
                  logWarningMessage(request, payload)
                }
              })
            }
          }
        }
      }
      return target.apply(that, args as never)
    }
  })
}
